import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react';
import LanguageObj from './LanguageWord.js';
import Cookies from 'js-cookie';
// import {setCookie, destroyCookie} from 'nookies';
// import nookies from 'nookies';
const LanguageContext = createContext();

export const LanguangeContextProvider = ({children}) => {
  const defaultLang = Cookies.get('languageCookie')
    ? Cookies.get('languageCookie')
    : 2;
  const [language, setLang] = useState(defaultLang);
  const changeLanguage = useCallback(
    (input) => {
      setLang(input);
    },
    [language, setLang]
  );

  useEffect(() => {
    Cookies.remove('languageCookie');
    Cookies.set('languageCookie', language);
  }, [language]);

  let newObj = {...LanguageObj};

  Object.keys(newObj).forEach((key) => {
    let arr = newObj[key];

    if (arr[1] === '') {
      arr[1] = arr[0];
    }

    if (arr[2] === '') {
      arr[2] = arr[0];
    }

    newObj[key] = arr;
  });

  return (
    <div>
      <LanguageContext.Provider value={{changeLanguage, language, newObj}}>
        {children}
      </LanguageContext.Provider>
    </div>
  );
};

export function Language() {
  return useContext(LanguageContext);
}
